import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MoveCheckboxComponent } from "./move-checkbox.component";
import { MiproSharedModule } from "@mipro/mipro-shared.module";
import { CheckboxModule } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";
import { MergeCheckboxComponent } from "./merge-checkbox.component";

@NgModule({
    declarations: [MoveCheckboxComponent, MergeCheckboxComponent],
    imports: [CommonModule, MiproSharedModule, CheckboxModule, FormsModule],
    exports: [MoveCheckboxComponent, MergeCheckboxComponent]
})
export class ConsultationMergeMoveModule {}
